import styled from "styled-components";

export default styled.div`
    align-items: center;
    background: #fff;
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 5px 10px 5px calc(4rem + 10px);
    position: sticky;
    top: 0;
    z-index: 1;
`;
